module.exports = __webpack_public_path__ + "img/n10.7a7c484c.jpeg";